import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseCameras = async ({ houseId, address }) => {
  return await request.get(
    `/Camera`,
    { houseId },
    `При загрузке видео с камер наблюдения по адресу ${address} произошла ошибка`,
    []
  );
};

const useHouseCameras = ({ houseId, address }, options) => {
  const id = typeof houseId === 'string' ? Number(houseId) : houseId;

  return useQuery(
    getQueryKeys.houseCameras(id),
    () => getHouseCameras({ houseId: id, address }),
    options
  );
};

export default useHouseCameras;
